module.exports = __webpack_public_path__ + "static/img/xian_yu_total@2x.8b948e2a.png";